"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @category Guard Factory
 * @return a Guard that checks if a value is **identical** to one of the values passed
 * @example
 * ```typescript
 *   const isCurrency = ValueOf(["USD", "EUR", "GBP"] as const);
 * ```
 */
const ValueOf = (expectedValues) => {
    return (value) => {
        return expectedValues.some(expected => value === expected);
    };
};
exports.default = ValueOf;
